
<template lang="html">
   <div class="listInsuranceService">

        

         <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
         <div></div>
         <div class="d-none d-md-block">
               <button class="btn btn-sm pd-x-15 btn-white btn-uppercase" @click="addInsuranceService">
                  <i data-feather="mail" class="wd-10 mg-r-5"></i> Add Service
               </button>     
         </div>
      </div>

        <ModalForm :showModal="showModal" :action="InsuranceServices.wizard.action">
         <template >
            <CustomForm 
               :pages="InsuranceServices.wizard.pages" 
               :action="InsuranceServices.wizard.action" 
               :buttonText="InsuranceServices.wizard.actionBtn" 
               :showTitle="false">
            </CustomForm>
         </template>
        </ModalForm>
        

       <div class="contents">
         <CustomTable 
            :tableFields="InsuranceServices.table.table_fields" 
            :tableData="InsuranceService" 
            :title="InsuranceServices.table.title" 
            :subtitle="InsuranceServices.table.subtitle" 
            :searchFields="InsuranceServices.table.searchFields"
            :rowData="InsuranceServices.table.rowData">
         </CustomTable>
      </div>
              
   </div>
</template>
<script>
export default {
  data() {
    return {
      InsuranceServices: {},
      InsuranceService: [],
      showModal: false,
      icons: [],
    };
  },
  async created() {
    this.InsuranceServices = Models.InsuranceServices;
    Event.$on("InsuranceService:view", (payload) => {
      this.$router.push({
        name: "ViewInsuranceService",
        params: { id: payload.service.service_code },
      });
    });

    Event.$on("form:submit", async (payload) => {
      if (payload.action === this.InsuranceServices.wizard.action) {
        await this.saveInsuranceService(payload.formData);
        this.showModal = false;
      }
    });

    Event.$on("modal:close", async (payload) => {
      this.showModal = false;
    });
  },

  async mounted() {
    await this.fetchInsuranceService();
    await this.getIcons();
    Event.$emit("loader:show", false);
  },

  methods: {
    getImg(path) {
      return req.getParsedUrl(path);
    },
    addInsuranceService() {
      this.showModal = true;
    },

    saveInsuranceService(data) {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await req.callServerSecure({
            resource: "services",
            action: "create",
            data: {
              service_code: data.service_code,
              service_name: data.service_name,
              service_type: data.service_type,
              service_category: data.service_category,
              service_description: data.service_description,
              service_image_path: data.service_image_path,
            },
            meta_data: {},
          });

          await this.fetchInsuranceService();
          notification.notify(
            "success",
            "Insurance Service Added",
            `The service ${data.service_name} was successfully added`
          );
          Event.$emit("form:action-complete", {
            action: this.InsuranceServices.wizard.action,
            clear: true,
          });
          this.showModal = false;
        } catch (err) {
          Event.$emit("form:action-error", {
            action: this.InsuranceServices.wizard.action,
          });
        }
      });
    },
    fetchInsuranceService() {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await req.callServerSecure({
            resource: "services",
            action: "list",
            data: {},
            meta_data: {},
          });
          this.InsuranceService = res.data.result.insurance_services.map(
            (item) => {
              item.service_image_path = domain + item.service_image_path;
              return item;
            }
          );
          resolve(true);
        } catch (err) {
          notification.notify(
            "error",
            "Fetching Insurance Service",
            `Fetching Insurance Service`
          );
          reject(err);
        }
      });
    },
    getIcons() {
      return new Promise(async (resolve, reject) => {
        try {
          let pages = this.InsuranceServices.wizard.pages;
          let res = await req.callServerSecure({
            resource: "icons",
            action: "list",
            data: {},
            meta_data: {},
          });
          (pages[0].forms[4].options = utils.appendOptions(
            res.data.result,
            "file_path",
            "originalname"
          )),
            resolve(true);
        } catch (err) {
          reject(err);
        }
      });
    },
  },
};
</script>
<style lang="less">
.listInsuranceService {
}
</style>